<template>
  <div class="mb-5" style="background-color: var(--color-light-light-gray); padding: 20px">
    <h4 class="h5 fw-bold mb-3">
      {{ $t("project.previewAndReport.consumption.title") }}
    </h4>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-1">
          <span class="fw-bold me-2">{{
            $t("project.previewAndReport.consumption.f1Total")
          }}</span>
          <span class="fw-normal"><span style="color: var(--description-color);">{{ consumptionData.totalF1 }}</span> kWh</span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-1">
          <span class="fw-bold me-2">{{
            $t("project.previewAndReport.consumption.f2Total")
          }}</span>
          <span class="fw-normal"><span style="color: var(--description-color);">{{ consumptionData.totalF2 }}</span> kWh</span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-1">
          <span class="fw-bold me-2">{{
            $t("project.previewAndReport.consumption.f3Total")
          }}</span>
          <span class="fw-normal"><span style="color: var(--description-color);">{{ consumptionData.totalF3 }}</span> kWh</span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-1">
          <span class="fw-bold me-2">{{
            $t("project.previewAndReport.consumption.grandTotal")
          }}</span>
          <span class="fw-normal"><span style="color: var(--description-color);">{{ consumptionData.grandTotal }}</span> kWh</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "ConsumptionSection",
  props: {
    consumptionData: {
      type: Object as PropType<{
        totalF1: number;
        totalF2: number;
        totalF3: number;
        grandTotal: number;
      }>,
      required: true,
    },
  },
});
</script>
